<template>
  <div class="main" :style="{'height': height + 'px'}" v-if="banner.length != 0">
    <transition-group name="img" tag="ul" class="picture" :style="{'width': width + 'px', 'height': height + 'px'}">
      <li class="picture-list"
          v-for="(item,index) in banner"
          :key="item.SortID"
          v-show="index===mark"
          @mouseover.stop="stop"
          @mouseleave="play">
        <img class="picture-list-img"
          :src="item.fileName"
          :key="index"
          :style="{'height': height + 'px'}"
          @click="common.linkList(item)">
      </li>
    </transition-group>
    <ul class="bannerBtn" >
      <li v-for="(num,index) in banner.length"
          :key="index" :class="['bannerBtn-item',{'bannerBtn-item-active':num-1===mark}]"
          @click="change(num-1)"
      ></li>
    </ul>
    <!-- <div class="arrow" v-if="isShowArrow" @mouseover.stop.stop="showArrow = true" @mouseleave.stop="showArrow = true" v-cloak @click="goList1()">

    </div> -->
     <div class="icon left" @click.stop="toLeft()" v-if="isShowArrow" v-cloak >
        <img src="../assets/icon/left-arrow-white.png" />
      </div>
      <div class="icon right" @click.stop="toRight()" v-if="isShowArrow" v-cloak>
         <img src="../assets/icon/right-arrow-white.png" />
      </div>

  </div>
</template>

<script>
  export default {
    name: "swiper",
    props:['banner', 'height', 'isShowArrow'],
    data() {
      return {
        width: 'auto',
        showArrow: true,
        currImgs: [],
        index: 0,
        mark: 0,
        timer: ''
      }
    },
    mounted() {
      this.play();
      this.width =  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    },
    methods: {
      play() {
        this.showArrow = true
        this.timer = setInterval(() => {
          if (this.mark < this.banner.length - 1) {
            this.mark++;
          } else {
            this.mark = 0;
          }
        }, 5000);
      },
      change(num) {
        this.mark = num;
        this.stop()
        this.play()
      },
      stop() {
        this.showArrow = true
        clearInterval(this.timer);
        this.timer = null;
      },
      toLeft() {
        this.stop()
        if(this.mark == 0) {
         this.mark = this.banner.length - 1
        } else {
          this.mark--
        }

        this.play()
      },
      toRight() {
        this.stop()
        if(this.mark < this.banner.length - 1) {
          this.mark++

        } else {
          this.mark = 0
        }
         this.play()

      },
      goList(id){
        this.$router.push({
          path: '/category',
          query:{
              WebFunctionID: id
          }
        })
      },
    
    }
  }
</script>

<style scoped lang="scss">
  @import "../style/color";
  .main {
    height: 400px;
    position: relative;
    .icon {
      width: 40px;
      height: 40px;
      position: absolute;
      border-radius: 50%;
      background: rgba(0, 0, 0, .2);
      top: 50%;
      margin-top: -20px;
      cursor: pointer;
      &:hover {
        background: rgba(0, 0, 0, .5);
      }
      img {
        width: 20px;
        height: 20px;
        margin: 10px;
      }
    }
    .left {
      left: calc((100% - 1050px) / 2)
    }
    .right {
      right: calc((100% - 1050px) / 2)
    }
    .picture {
      height: 400px;
      width: 100%;

      &-list {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        min-width: 1050px;
        box-sizing: border-box;
        text-align: center;
         display: flex;
        justify-content: center;
        &-img {
          // width: 100%;
          height: 400px;
          cursor: pointer;
        }
      }
    }

    .img-enter-active, .img-leave-active {
      transition: all 1s;
    }

    .img-enter, .img-leave-to {
      opacity: 0;
    }

    .img-enter-to, .img-leave {
      opacity: 1;
    }

    .bannerBtn {
      position: absolute;
      left: 50%;
      bottom: 0;
      height: 20px;
      text-align: center;
      z-index: 100;
      transform: translate(-50%, -50%);

      &-item {
        float: left;
        margin-left: 2.5px;
        margin-top: 1.5px;
        width: 15px;
        height: 15px;
        background: $c_0fff;
        border-radius: 50%;
        margin-right:10px;
        transition: all 2s ease;
        cursor: pointer;
      }

      &-item-active {
        background: $c_6DB;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/swiper.vue